module.exports = __webpack_public_path__ + "static/media/7ICJ4.3cd86839.jpg";